import { lazy, Suspense } from "react";
import { Outlet, useRoutes } from "react-router-dom";
import EditSport from "./components/screens/sports/EditSport";
import AllHealth from "./components/screens/health/AllHealth";
import CreateNewHealth from "./components/screens/health/CreateNewHealth";
import EditHealth from "./components/screens/health/EditHealth";
import AllDeath from "./components/screens/deaths/AllDeath";
import CreateNewDeath from "./components/screens/deaths/CreateNewDeath";
import EditDeath from "./components/screens/deaths/EditDeath";
import AllParishNews from "./components/screens/parishNews/AllParishNews";
import CreateNewParishNews from "./components/screens/parishNews/CreateNewParishNews";
import EditParishNews from "./components/screens/parishNews/EditParishNews";
import AllChurchNews from "./components/screens/churchNews/AllchurchNews";
import CreateNewChurchNews from "./components/screens/churchNews/createNewChurchNews";
import EditChurchNews from "./components/screens/churchNews/EditChurchNews";
import AllMiscellaneousNews from "./components/screens/MiscellaneousNews/AllMiscellaneousNews";
import CreateNewMiscellaneousNews from "./components/screens/MiscellaneousNews/CreateNewMiscellaneousNews";
import EditMiscellaneousNews from "./components/screens/MiscellaneousNews/EditMiscellaneousNews";
import AllPastoralActivities from "./components/screens/pastoralActivities/AllPastoralActivities";
import CreateNewPastoralActivity from "./components/screens/pastoralActivities/CreateNewPastoralActivity";
import EditPastoralActivity from "./components/screens/pastoralActivities/EditPastoralActivity";
import AllOpinionThoughts from "./components/screens/opinionToughts/AllOpinionThoughts";
import CreateNewOpinionThoughts from "./components/screens/opinionToughts/CreateNewOpinionThoughts";
import EditOpinionThoughts from "./components/screens/opinionToughts/EditOpinionThoughts";
import AllReadings from "./components/screens/readings/AllReadings";
import CreateNewReading from "./components/screens/readings/CreateNewReading";
import EditReading from "./components/screens/readings/EditReading";
import AllHistory from "./components/screens/history/AllHistory";
import CreateNewHistory from "./components/screens/history/CreateNewHistory";
import EditHistory from "./components/screens/history/EditHistory";
import CreateNewSaint from "./components/screens/saint/CreateNewSaint";
import AllSaint from "./components/screens/saint/AllSaint";
import EditSaint from "./components/screens/saint/EditSaint";
import Home from "./components/screens/Home";

export const Navbar = lazy(() => import("./components/navbar/Navbar"));
export const CreateNewSport = lazy(() =>
  import("./components/screens/sports/CreateNewSport")
);
export const AllSports = lazy(() =>
  import("./components/screens/sports/AllSports")
);

// ----------------------------------------------------------------------

export default function Routers() {
  const routes = useRoutes([
    {
      path: "/",
      element: (
        <Navbar>
          <Suspense>
            <Outlet />
          </Suspense>
        </Navbar>
      ),

      children: [
        { path: "/", element: <Home /> },
        { path: "sports/create-new", element: <CreateNewSport /> },
        { path: "sports/all", element: <AllSports /> },
        { path: "sports/edit-sport", element: <EditSport /> },

        { path: "health/create-new", element: <CreateNewHealth /> },
        { path: "health/all", element: <AllHealth /> },
        { path: "health/edit-health", element: <EditHealth /> },

        { path: "death/create-new", element: <CreateNewDeath /> },
        { path: "death/all", element: <AllDeath /> },
        { path: "death/edit-death", element: <EditDeath /> },

        { path: "parish-news/create-new", element: <CreateNewParishNews /> },
        { path: "parish-news/all", element: <AllParishNews /> },
        { path: "parish-news/edit-news", element: <EditParishNews /> },

        { path: "church-news/create-new", element: <CreateNewChurchNews /> },
        { path: "church-news/all", element: <AllChurchNews /> },
        { path: "church-news/edit-news", element: <EditChurchNews /> },

        {
          path: "miscellaneous-news/create-new",
          element: <CreateNewMiscellaneousNews />,
        },
        { path: "miscellaneous-news/all", element: <AllMiscellaneousNews /> },
        {
          path: "miscellaneous-news/edit-news",
          element: <EditMiscellaneousNews />,
        },

        {
          path: "pastoral-activity/create-new",
          element: <CreateNewPastoralActivity />,
        },
        { path: "pastoral-activity/all", element: <AllPastoralActivities /> },
        {
          path: "pastoral-activity/edit-news",
          element: <EditPastoralActivity />,
        },

        {
          path: "opinion-thoughts/create-new",
          element: <CreateNewOpinionThoughts />,
        },
        { path: "opinion-thoughts/all", element: <AllOpinionThoughts /> },
        {
          path: "opinion-thoughts/edit-news",
          element: <EditOpinionThoughts />,
        },

        { path: "readings/create-new", element: <CreateNewReading /> },
        { path: "readings/all", element: <AllReadings /> },
        { path: "readings/edit-news", element: <EditReading /> },

        { path: "history/create-new", element: <CreateNewHistory /> },
        { path: "history/all", element: <AllHistory /> },
        { path: "history/edit", element: <EditHistory /> },

        { path: "saint/create-new", element: <CreateNewSaint /> },
        { path: "saint/all", element: <AllSaint /> },
        { path: "saint/edit", element: <EditSaint /> },
      ],
    },
  ]);

  return routes;
}
